import moment from 'moment';

let throttles = {};

/**
 * @description Throttles a function with a given time(ms)
 *
 * @param {function} func - Function to throttle
 * @param {string} key - Identifier for sessionStorage
 * @param {number} ms - Milliseconds to throttle
 * @returns result from function
 */
export default async function throttle(func, key, ms) {
	if (!negotiateThrottle(key, ms)) {
		func();
	}
}

function negotiateThrottle(key, ms) {
	let now = moment();
	let previousDate = getDate(key);

	if (previousDate && now.diff(previousDate) < ms) {
		return true;
	}
	setDate(key, now);
	return false;
}

function getDate(key) {
	let item = throttles[key];
	return item && moment(item);
}

function setDate(key, date) {
	let storedDate = date.toISOString();
	throttles[key] = storedDate;
}
